var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"85ec55aa9ce2b965e8e15c00cbd67ead9b4d1c18"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@otovo"]={id:"85ec55aa9ce2b965e8e15c00cbd67ead9b4d1c18"};
      